
import { Component, Vue, Prop } from "vue-property-decorator";
import ImageBox from "@/components/Base/ImageBox.vue";
import ImageSelector from "@/components/Base/ImageSelector.vue";
import StringHelper from "@/utils/StringHelper";
import { Season } from "@/models/GameType";
import { cloneDeep } from "lodash";

@Component({
  components: { ImageSelector, ImageBox },
})
class AddFX extends Vue {
  @Prop({ default: null }) readonly seasonData!: Season;
  displayName = "";
  description = "";
  seasonDataObject = {} as Season;
  errorMessage = "";

  get getSlugifyName(): string {
    return StringHelper.Slugify(this.displayName);
  }
  get getSeasonData(): Season[] {
    return this.$store.state.gameStore.gameType;
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  updated(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  cancel(): void {
    this.$bvModal.hide("team-modal-add-fx");
  }
  saveFx(): void {
    var data = {
      slug: this.getSlugifyName,
      desc: this.description,
    };
    if (this.seasonData.fx[this.getSlugifyName] !== undefined) {
      this.errorMessage = "An slug with the same slug already exists.";
      this.$bvModal.show("modal-sm");
    } else {
      if (this.displayName.length > 0 && /[a-z]/i.test(this.displayName)) {
        if (this.seasonDataObject.fx !== undefined) {
          this.seasonDataObject.fx[this.getSlugifyName] = data;

          this.$store.dispatch(
            "gameStore/updateSeasonType",
            this.seasonDataObject
          );
          this.displayName = "";
          this.description = "";
          this.$bvModal.hide("team-modal-add-fx");
        }
      } else {
        this.$bvModal.show("modal-sm");
        this.errorMessage =
          "Please make sure the display name is not empty and contains at least one letter";
      }
    }
  }
}

export default AddFX;
